







































































































































































































import Vue from 'vue';
import moment from 'moment';
import customerVuex from '../../vuex/common';
import { CustomerRemarkRuleType } from '../../models/CustomerRemarkRule';
import customerClient from '../../apis';

export default Vue.extend({
  mixins: [customerVuex],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CustomerRemarkRuleType,
      showBox: false,
      loading: true,
      hackId: 0,
      permanentValue: 1,
      fullMatchValue: 1,
      startNowValue: 1,
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null,
    };
  },
  computed: {
    isService(): boolean {
      return this.accountState.account.weixinType === 1;
    },
  },
  methods: {
    updateType(type: CustomerRemarkRuleType) {
      this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE', {
        key: 'type',
        value: type,
      });
      this.hackId++;
    },
    updateLink(e: Event) {
      const value = (e.target as any).value;
      this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE_LINK', {
        key: 'oriLink',
        value: value.trim(),
      });
    },
    updateTitle(e: Event) {
      const value = (e.target as any).value;
      this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE_LINK', {
        key: 'title',
        value: value.trim(),
      });
    },
    updateRemark(e: Event) {
      const value = (e.target as any).value;
      this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE', {
        key: 'remark',
        value,
      });
      this.hackId++;
    },
    updatePermanent(value: number) {
      this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE', {
        key: 'permanent',
        value: value === 1,
      });
    },
    updateKeyword(e: Event) {
      const value = (e.target as any).value;
      this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE_KEYWORD', {
        key: 'keyword',
        value,
      });
    },
    updateFullMatch(value: number) {
      this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE_KEYWORD', {
        key: 'fullMatch',
        value: value === 1,
      });
    },
    updateStartNow(value: number) {
      this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE_PERIOD', {
        key: 'startNow',
        value: value === 1,
      });
    },
    updateStartDate(date: string) {
      this.startDate = date;
    },
    updateStartTime(time: string) {
      this.startTime = time;
    },
    updateEndDate(date: string) {
      this.endDate = date;
    },
    updateEndTime(time: string) {
      this.endTime = time;
    },
    validateRule(): boolean {
      const rule = this.customerRemarkRule;
      if (rule.type === CustomerRemarkRuleType.Link) {
        if (!rule.link.title || rule.link.title.trim() === '') {
          this.$Message.warning('请填写标题');
          return false;
        }
        if (!rule.link.oriLink || rule.link.oriLink.trim() === '') {
          this.$Message.warning('请输入页面网址');
          return false;
        }
      }
      if (rule.type === CustomerRemarkRuleType.Keyword) {
        if (!rule.keyword.keyword || rule.keyword.keyword.trim() === '') {
          this.$Message.warning('请填写关键词');
          return false;
        }
      }
      if (!rule.remark || rule.remark.trim() === '') {
        this.$Message.warning('请填写标签名称');
        return false;
      }
      if (!this.customerRemarkRule.permanent) {
        if (!this.customerRemarkRule.period.startNow) {
          if (!this.startDate) {
            this.$Message.warning('请选择开始日期');
            return false;
          }
          if (!this.startTime) {
            this.$Message.warning('请选择开始时间');
            return false;
          }
        }
        if (!this.endDate) {
          this.$Message.warning('请选择结束日期');
          return false;
        }
        if (!this.endTime) {
          this.$Message.warning('请选择结束时间');
          return false;
        }
        const now = moment().format('YYYY-MM-DD hh:mm:ss');
        let startAt = moment().format('YYYY-MM-DD hh:mm:ss');
        if (!this.customerRemarkRule.period.startNow) {
          startAt = `${this.startDate} ${this.startTime}:00`;
        }
        const endAt = `${this.endDate} ${this.endTime}:00`;
        if (startAt >= endAt) {
          this.$Message.warning('开始时间必须小于结束时间');
          return false;
        }
        if (endAt <= now) {
          this.$Message.warning('结束时间必须大于当前时间');
          return false;
        }
      }
      return true;
    },
    doSubmit() {
      if (!this.customerRemarkRule.permanent) {
        if (!this.customerRemarkRule.period.startNow) {
          this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE_PERIOD', {
            key: 'startAt',
            value: `${this.startDate} ${this.startTime}:00`,
          });
        }
        this.$store.commit('UPDATE_CUSTOMER_REMARK_RULE_PERIOD', {
          key: 'endAt',
          value: `${this.endDate} ${this.endTime}:00`,
        });
      }
      if (this.customerRemarkRule.id) {
        customerClient.updateRemarkRule({
          id: this.customerRemarkRule.id,
          type: this.customerRemarkRule.type,
          permanent: this.customerRemarkRule.permanent,
          period: !this.customerRemarkRule.permanent ? this.customerRemarkRule.period : undefined,
        }).success((r: any) => {
          this.$Message.success('修改成功');
          this.$emit('success');
          this.loading = true;
        });
      } else {
        customerClient.createRemarkRule(this.customerRemarkRule).success((r: any) => {
          this.$Message.success('创建成功');
          this.$emit('success');
          this.loading = true;
        });
      }
    },
    confirm() {
      if (this.validateRule()) {
        this.doSubmit();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    },
  },
  mounted() {
    this.showBox = this.show;
    this.permanentValue = this.customerRemarkRule.permanent ? 1 : 0;
    if (this.customerRemarkRule.keyword) {
      this.fullMatchValue = this.customerRemarkRule.keyword.fullMatch ? 1 : 0;
    }
    if (!this.customerRemarkRule.permanent) {
      this.startNowValue = this.customerRemarkRule.period.startNow ? 1 : 0;
      if (this.startNowValue === 0) {
        this.startDate = this.customerRemarkRule.period.startAt.substring(0, 10);
        this.startTime = this.customerRemarkRule.period.startAt.substring(11, 16);
      }
      this.endDate = this.customerRemarkRule.period.endAt.substring(0, 10);
      this.endTime = this.customerRemarkRule.period.endAt.substring(11, 16);
    }
    if (!this.isService) {
      this.updateType(CustomerRemarkRuleType.Keyword);
    }
  },
  watch: {
    show() {
      this.showBox = this.show;
    },
  },
});
